import { ReactNode } from 'react';
import { MediaManagerSDKFile } from '../../../../typings/media-manager-sdk';

export enum ModalTheme {
  Red = 'red',
}

export enum ModalName {
  DeleteVideoFile = 'deleteVideoFileModal',
}

export interface IAdditionalOptions {
  file?: MediaManagerSDKFile;
}

export interface IModalOptions {
  title: ReactNode;
  confirmText: ReactNode;
  cancelText: ReactNode;
  theme: ModalTheme;
  message: ReactNode;
  onOk?: (additionalOptions: IAdditionalOptions) => void;
  onCancel?: (additionalOptions: IAdditionalOptions) => void;
  onClose?: (additionalOptions: IAdditionalOptions) => void;
}
